import css from 'styled-jsx/css';

export default css`.item {
  margin: 12px 0;
  margin-top: 12px;
  cursor: pointer;
  margin-left: 7px;
  margin-right: 7px; }

.icon {
  margin: 0 auto;
  margin-bottom: 8px;
  display: block;
  width: 62px;
  height: 62px;
  background-size: 62px; }

.text {
  text-align: center;
  font-size: .7rem;
  color: #333; }
`